import React from 'react';
import * as PropTypes from 'prop-types';
import MaterialTable, {MTableAction, MTableHeader} from 'material-table';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import withStyles from "@material-ui/styles/withStyles/withStyles";
import {green, orange, red} from "@material-ui/core/colors";
import {AddCircleTwoTone, CheckTwoTone, ClearTwoTone, DeleteForeverTwoTone, EditTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";
import MTableCell2 from "./MTableCell2";
import MTableEditField2 from "./MTableEditField2";

const RedButton = withStyles(theme => ({
    root: {
        color: theme.palette.getContrastText(red[500]),
        backgroundColor: red[500],
        '&:hover': {
            backgroundColor: red[700],
        },
    },
}))(Button);

const GreenButton = withStyles(theme => ({
    root: {
        color: theme.palette.getContrastText(green[200]),
        backgroundColor: green[200],
        '&:hover': {
            backgroundColor: green[500],
        },
    },
}))(Button);

const OrangeButton = withStyles(theme => ({
    root: {
        color: theme.palette.getContrastText(orange[500]),
        backgroundColor: orange[500],
        '&:hover': {
            backgroundColor: orange[700],
        },
    },
}))(Button);

class MuiTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            data: [],
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data !== this.props.data) {
            this.setState({data: nextProps.data });
        }
    }

    componentDidMount() {
        this.setState({
            columns: this.props.columns,
            data: this.props.data,
        });
    }

    render() {
        console.log('this.props.onExport', this.props.onExport);
        const { state } = this;
        return (
            <MaterialTable
                {...this.props}
                title={this.props.title}
                localization={{
                    header: { actions: "" }
                }}
                columns={state.columns}
                data={state.data}
                editable={{
                    isEditable: rowData => (rowData.immutable !== true && this.props.allowUpdateDelete !== 'no'),
                    isDeletable: rowData => (rowData.immutable !== true && this.props.allowUpdateDelete !== 'no'),
                    onRowAdd: newData =>
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                if (!this.props.isValid(newData)) {
                                    return reject();
                                }
                                resolve();
                                this.setState(prevState => {
                                    const data = [...prevState.data];
                                    data.push(newData);
                                    console.log('adding');
                                    console.log(newData);
                                    this.props.onAdd(newData);
                                    return {...prevState, data};
                                });
                            }, 600);
                        }),
                    onRowUpdate: (newData, oldData) =>
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve();
                                if (oldData) {
                                    this.setState(prevState => {
                                        const data = [...prevState.data];
                                        data[data.indexOf(oldData)] = newData;
                                        console.log('updating ' + newData);
                                        this.props.onUpdate(newData);
                                        return {...prevState, data};
                                    });
                                }
                            }, 600);
                        }),
                    onRowDelete: oldData =>
                        new Promise(resolve => {
                            setTimeout(() => {
                                resolve();
                                this.setState(prevState => {
                                    const data = [...prevState.data];
                                    data.splice(data.indexOf(oldData), 1);
                                    console.log('deleting ');
                                    console.log(oldData);
                                    this.props.onDelete(oldData);
                                    return {...prevState, data};
                                });
                            }, 600);
                        }),
                }}
                icons={{
                    /* eslint-disable react/display-name */
                    Add: React.forwardRef((props, ref) => this.props.allowUpdateDelete !== 'no' && <OrangeButton startIcon={<AddCircleTwoTone/>} {...props} ref={ref}>New Template</OrangeButton>),
                    Check: React.forwardRef((props, ref) => <GreenButton startIcon={<CheckTwoTone/>} {...props} ref={ref}>SAVE</GreenButton>),
                    Clear: React.forwardRef((props, ref) => <RedButton {...props} startIcon={<ClearTwoTone/>} ref={ref}>CANCEL</RedButton>),
                    Delete: React.forwardRef((props, ref) => this.props.allowUpdateDelete !== 'no' && <RedButton startIcon={<DeleteForeverTwoTone/>} {...props} ref={ref}>REMOVE</RedButton>),
                    DetailPanel: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>chevron_right</Icon>),
                    Edit: React.forwardRef((props, ref) => this.props.allowUpdateDelete !== 'no' && <GreenButton startIcon={<EditTwoTone/>} {...props} ref={ref}>EDIT</GreenButton>),
                    Export: React.forwardRef((props, ref) => null),
                    Filter: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>filter_list</Icon>),
                    FirstPage: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>first_page</Icon>),
                    LastPage: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>last_page</Icon>),
                    NextPage: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>chevron_right</Icon>),
                    PreviousPage: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>chevron_left</Icon>),
                    ResetSearch: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>clear</Icon>),
                    Search: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>search</Icon>),
                    SortArrow: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>arrow_downward</Icon>),
                    ThirdStateCheck: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>remove</Icon>),
                    ViewColumn: React.forwardRef((props, ref) => <Icon {...props} ref={ref}>view_column</Icon>),
                    /* eslint-enable react/display-name */
                }}
                options={{
                    actionsColumnIndex: -1,
                    exportButton: false,
                    pageSize: this.props.pageSize ? this.props.pageSize : 20,
                    pageSizeOptions: [20, 50, 100],
                    search: this.props.search !== false,
                    headerStyle: {...this.props.headerStyle, width: "10%"},
                }}
                actions={[
                    {
                        icon: 'export',
                        tooltip: 'Export',
                        isFreeAction: true,
                        isDisplay: this.props.exportButton,
                        onClick: (event, rowData) => {
                            this.props.onExport();
                        }
                    }
                ]}
                components={{
                    // Body: props => ( <MuiTableBody2 {...props}/>),
                    Header: props => (<MTableHeader {...props} style={{ width: "10%"}}/>),
                    Cell: props => ( <MTableCell2 {...props} handleFileUpload={this.props.handleFileUpload}/>),
                    EditField: props => (<MTableEditField2 {...props} defaultData={this.props.defaultData} handleFileUpload={this.props.handleFileUpload}
                       onOptionalDateChange={event => {
                            console.log('optionalValue changing', this.state.optionalValue);
                            console.log('event.target.checked', event.target.checked);
                            this.setState({ optionalValue: event.target.checked }, () => {console.log('new value', this.state.optionalValue);});
                       }} optionalValue={this.state.optionalValue === undefined ? false : this.state.optionalValue}/>),
                    Action: props => {
                        if (props.action.icon === 'export') {
                            console.log('props', props);
                            if (props.action.isDisplay !== false) {
                                return <GreenButton startIcon={<SystemUpdateAltTwoTone/>}
                                                    onClick={(event) => props.action.onClick(event, props.data)}
                                                    style={{marginLeft: "20px"}}>EXPORT</GreenButton>
                            } else {
                                return null;
                            }
                        }
                        return <MTableAction {...props}/>
                    }
                }}
                headerStyle={{
                    background: "gray"
                }}
                />
        );
    }
}

MuiTable.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    onAdd: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    isValid: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    headerStyle: PropTypes.object,
    defaultData: PropTypes.object,
    handleFileUpload: PropTypes.func,
    onExport: PropTypes.func,
    pageSize: PropTypes.number,
    search: PropTypes.bool,
    exportButton: PropTypes.bool,
};

export default MuiTable;